import React from 'react';
import { PlatformIcon } from '@cubemeet/ui';

interface WebIconProps {
  name: string;
  size?: number;
  color?: string;
  family?: 'MaterialCommunityIcons' | 'MaterialIcons';
}

const WebIcon: React.FC<WebIconProps> = ({ name, size = 18, color = '#000', family }) => (
  <PlatformIcon name={name} size={size} color={color} family={family} />
);

export default WebIcon;
